import React, { Component } from 'react';
//Custom Components
import AppShowcase from '../components/AppShowcase'

class Home extends Component {
  render() {
    return (
    	<div>
			<div>
				<AppShowcase/>
			</div>
		</div>
    );
  }
}
export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js